import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipSwitchPayButtonComponent } from './payment-sip-switch-pay-button.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [PaymentSipSwitchPayButtonComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [PaymentSipSwitchPayButtonComponent]
})
export class PaymentSipSwitchPayButtonModule { }
